import React, {Component} from 'react';
import { connect } from 'react-redux';
import Paper from '@mui/material/Paper';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import {IconButton, Tooltip, CircularProgress} from '@mui/material';
import { mdiCalendarEdit } from '@mdi/js';
import Icon from '@mdi/react';
import PSLFEmployerDetails from '../../PSLFEmployerDetails';
import DateEdit from './DateEdit';
import { showError, showMessage, confirmAction } from '../../../actions/uiActions';
import FormsApi from '../../../api/forms';
import { Delete } from '@mui/icons-material';
import { getMSDIDRRecertificationDate } from "../../../utils/AnalysisTools"
class RecertificationDates extends Component {
    state = {
        edit: null,
        msdSuggestedIDR: null
    }

    componentDidMount = () => {
        if (this.props.user.myStudentData.student_loans) {
            this.setState({
                msdSuggestedIDR: !this.props.idr && getMSDIDRRecertificationDate(this.props.user.myStudentData)
            })
        }
    }

    handleEdit = (type, isProcessing, date, employer = null) => {
        this.setState({
            edit: {
                type: type,
                processing: isProcessing,
                date: date ? moment(date, 'X') : null,
                employer
            }
        })
    }

    setProcessing = () => {
        this.setState({
            edit: {
                ...this.state.edit,
                processing: true
            }
        });
    }

    triggerUpdate = async (details) => {
        details.date = Number(moment(details.date, 'YYYY-MM-DD').format('X'));
        this.setProcessing()
        try {
            await FormsApi.setRecertificationDate(this.props.user._id, details);
            this.props.showMessage("The recertification date has been updated.");
            this.props.onRecertificationDateUpdated(details);
        } catch (message) {
            this.props.showError(message || "There was an error setting the recertification date");
        } finally {
            this.setState({ edit: null });
        }
    }

    submitForUpdate = (date, employerName = '') => {
        const { edit: updateDetails, msdSuggestedIDR } = this.state;
        updateDetails.date = date;
        if (updateDetails.type === "IDR") {
            if (this.props.idr) {
                updateDetails.servicer = this.props.idr.servicer
            } else if (msdSuggestedIDR) {
                updateDetails.servicer = msdSuggestedIDR.servicer
            } else {
                updateDetails.servicer = "Unknown servicer"
            }
        } else if (updateDetails.type === "TLF") {
            updateDetails.employer_name = employerName
        }
        if(moment(updateDetails.date,"YYYY-MM-DD").subtract(90, "days") < moment()) {
            this.props.confirmAction("The date you set for this event may trigger the recertification process for this user. Do you want to proceed?",()=>this.triggerUpdate(updateDetails));
        } else {
            this.triggerUpdate(updateDetails)
        }
    }

    deletePSLFRecertificationDate = async () => {
        try {
            await FormsApi.deletePSLFRecertificationDate(this.props.user._id);
            this.props.showMessage("The recertification date has been deleted.");
            this.props.onRecertificationDateUpdated({
                type: 'PSLF',
                deleted: true
            });
        } catch (message) {
            this.props.showError(message || "There was an error deleting the recertification date");
        } finally {
            this.setState({ edit: null });
        }
    }

    formatEmployerProperty = (employer) => {
        return {
            ...employer,
            official_phone: employer.phone,
            official_email: employer.email,
        }
    }

    getMoreText = () => {
        if (this.state.msdSuggestedIDR) {
            return `Suggested IDR Recertification date based on MSD is ${this.state.msdSuggestedIDR.date}`;
        }
        return false;
    }

    render() {
        const { idr, pslf, tlf } = this.props;
        const { edit, msdSuggestedIDR } = this.state;
        const isEditing = edit && edit.processing

        return (
            <Paper className="margin-bottom20px">
                {edit && <DateEdit
                    date={this.state.edit.date}
                    employer={this.state.edit.employer}
                    onClose={() => this.setState({ edit:null })}
                    onSubmit={ this.submitForUpdate }
                    moreText={this.getMoreText()}
                    isTLFForm={edit.type === "TLF"}
                />}
                <Accordion>
                    <AccordionSummary>Recertification Dates</AccordionSummary>
                    <AccordionDetails>
                        <Table>
                            <TableHead>
                                <TableCell className="width40pct">
                                    Form Name
                                </TableCell>
                                <TableCell className="width15pct ">
                                    Recertification Date
                                </TableCell>
                                <TableCell className="width20pct text-center">
                                    Actions
                                </TableCell>
                            </TableHead>
                            <TableBody>
                                {
                                    <TableRow>
                                        <TableCell>IDR Recertification Date</TableCell>
                                        <TableCell>{ idr && idr.date ? moment(idr.date, 'X').format('MM/DD/YYYY') : msdSuggestedIDR && moment(msdSuggestedIDR.date).format('MM/DD/YYYY') }</TableCell>
                                        <TableCell className="text-center">
                                            {/* {form.actionable&&this.canRecert(formInfo)&&<Tooltip title="Re-assign form for recertification">
                                                <IconButton onClick={()=>this.reassign(formInfo)}>
                                                    <Repeat />
                                                </IconButton>
                                            </Tooltip>} */}
                                            {!isEditing && <Tooltip title="Edit event date">
                                                <IconButton onClick={() => {
                                                    const idrDate = this.props.idr ? this.props.idr.date : null
                                                    this.handleEdit("IDR", false, idrDate)
                                                }}>
                                                    <Icon path={mdiCalendarEdit} size={1} />
                                                </IconButton>
                                            </Tooltip>}
                                            {isEditing && <CircularProgress size={16} />}
                                        </TableCell>
                                    </TableRow>
                                }
                                {pslf && (
                                    <TableRow>
                                        <TableCell>
                                            <span>PSLF Employment Certification</span>
                                            {pslf.employer && <PSLFEmployerDetails employer={this.formatEmployerProperty(pslf.employer)} />}
                                        </TableCell>
                                        <TableCell>{moment(pslf.recertificationDate, 'X').format('MM/DD/YYYY')}</TableCell>
                                        <TableCell className="text-center">
                                            {/* {form.actionable&&this.canRecert(formInfo)&&<Tooltip title="Re-assign form for recertification">
                                                <IconButton onClick={()=>this.reassign(formInfo)}>
                                                    <Repeat />
                                                </IconButton>
                                            </Tooltip>} */}
                                            {!isEditing && <>
                                                <Tooltip title="Edit event date">
                                                    <IconButton onClick={() => {
                                                        this.handleEdit("PSLF", false, this.props.pslf.recertificationDate)
                                                    }}>
                                                        <Icon path={mdiCalendarEdit} size={1} />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Delete event date">
                                                    <IconButton onClick={this.deletePSLFRecertificationDate}>
                                                        <Delete />
                                                    </IconButton>
                                                </Tooltip>
                                                </>}
                                            {isEditing && <CircularProgress size={16} />}
                                        </TableCell>
                                    </TableRow>
                                )}
                                <TableRow>
                                    <TableCell>
                                        <span>TLF Forgiveness Date</span>
                                        {tlf.employer && <PSLFEmployerDetails employer={this.formatEmployerProperty(tlf.employer)} canOpen={false} />}
                                    </TableCell>
                                    <TableCell>{moment(tlf.tlfForgivenessDate, 'X').format('MM/DD/YYYY')}</TableCell>
                                    <TableCell className="text-center">
                                        {!isEditing && <>
                                            <Tooltip title="Edit event date">
                                                <IconButton onClick={() => {
                                                    this.handleEdit("TLF", false, tlf.tlfForgivenessDate ?? '', tlf.employer || '')
                                                }}>
                                                    <Icon path={mdiCalendarEdit} size={1} />
                                                </IconButton>
                                            </Tooltip>
                                        </>}
                                        {isEditing && <CircularProgress size={16} />}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </AccordionDetails>
                </Accordion>
            </Paper>
        )
    }
}

export default connect(null,{ showError, showMessage, confirmAction })(RecertificationDates);
